export const calcImageWidth = (productsCount: number) => {
  if (productsCount >= 5) {
    return {
      md: '18vw',
      lg: '16vw',
      max: '230px',
    };
  }

  if (productsCount === 4) {
    return {
      md: '22vw',
      lg: '15vw',
      max: '220px',
    };
  }

  return {
    md: '30vw',
    lg: '19vw',
    max: '300px',
  };
};
